module.exports = __webpack_public_path__ + "img/power_consumption.80db7050.png";